import styled from '@emotion/styled';

const SupportTileTitle = styled('h4')({
  textAlign: 'center',
  fontWeight: 400,
});

export default SupportTileTitle;
